import {applyMiddleware, compose, createStore} from 'redux';
import reducers from './reducers';
import {createBrowserHistory /*, createHashHistory*/} from "history"; // choose one, Neo!
import {routerMiddleware} from "connected-react-router";
import * as asyncInitialState from 'redux-async-initial-state';
import localStorage from '../util/localStorage';

const loadStore = (getCurrentState) => {
    return new Promise(resolve => {
        console.log('loading state...');
        localStorage.getItem('formSent')
            .then(val => {
                const currentState = getCurrentState();
                const newState = {
                    ...getCurrentState(),
                    main: {
                        ...currentState.main,
                        formSent: val === true
                    }
                };
                console.log('state loaded');
                resolve(newState);
            });
    });
};

// https://github.com/supasate/connected-react-router/blob/master/FAQ.md#how-to-set-router-props-eg-basename-initialentries-etc
const history = createBrowserHistory({basename: process.env.REACT_APP_ROUTER_BASENAME});
history.listen(loc => {
    console.log('*** location', loc);
    const ga = window.ga;
    if (ga) {
        ga('set', 'page', loc.pathname);
        ga('send', 'pageview');
    }

    const _hsq = window._hsq = window._hsq || [];
    _hsq.push(['setPath', loc.pathname]);
    _hsq.push(['trackPageView']);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'pageview',
        page: {
            path: loc.pathname,
            // title: 'Your custom title'
        }
    });
});
const routeMiddleware = routerMiddleware(history);

const middlewares = [asyncInitialState.middleware(loadStore), routeMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
    asyncInitialState.outerReducer(reducers(history)),
    //compose(applyMiddleware(asyncInitialState.middleware(loadStore))),
    composeEnhancers(applyMiddleware(...middlewares)));

export {history};